import { ref } from "vue";

const activeComponent = ref<string>();
const setComponent = (component: string) => {
	activeComponent.value = component;
}

const usePassengerDetailPages = () => {
	return { setComponent, activeComponent }
}

export default usePassengerDetailPages;